export const navLabels = {
  en: { home: 'Home', reading: 'Reading', schedule: 'Schedule', bible: 'The Bible' },
  es: { home: 'Inicio', reading: 'Lectura', schedule: 'Horario', bible: 'La Biblia' },
  zh: { home: '首頁', reading: '閱讀', schedule: '計劃', bible: '聖經' },
  sc: { home: '首页', reading: '阅读', schedule: '计划', bible: '圣经' },
};
